

































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import { GetResourceList } from "@/request/common";
@Component({})
export default class Name extends mixins(listMixin) {
  @Prop()
  private type: any;
  @Prop()
  private selected: any;
  @Prop()
  private IfShow: any;
  @Watch("IfShow", { immediate: true })
  private IfShowChange() {
    this.ifVisible = this.IfShow;
    if (this.IfShow) {
      this.filters.search = "";
      this.filters.sort_field = "update_time";
      this.selectedMessages = [];
      this.getList();
    }
  }
  private ifVisible: any = false;
  private data: any = [];
  private goZhishidian(item: any) {
    this.$emit("changeZhishidian", item);
    // this.$router.push({
    //   path: "/main/teacher/textbook/associated-resources",
    //   query: {
    //     data: JSON.stringify(item),
    //     type: this.type,
    //   },
    // });
  }
  private cancel() {
    this.$emit("cancel");
  }
  private sure() {
    if (this.selectedMessages.length == 0) {
      this.$message.warning("请选择需要关联的知识点");
      return;
    }
    this.$emit("change", this.selectedMessages);
  }
  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params = {
      search: this.filters.search,
      类别: this.type,
      order_key: this.filters.sort_field,
      order_value: this.filters.sort_value,
      current_page: this.filters.current_page,
      page_count: this.filters.page_count,
    };
    GetResourceList(this, params, loading)
      .then((res: any) => {
        loading.close();
        res.data.forEach((element: any) => {
          const inc = this.selectedMessages.findIndex((i: any) => {
            return i["ziyuan_id"] === element["ziyuan_id"];
          });
          if (inc !== -1) {
            element["selected"] = true;
          } else {
            element["selected"] = false;
          }
          const inc2 = this.selected.findIndex((i: any) => {
            return i["ziyuan_id"] === element["ziyuan_id"];
          });
          if (inc2 !== -1) {
            element["disabled"] = true;
          } else {
            element["disabled"] = false;
          }
        });
        this.data = res.data;
        this.filters.total_count = res.total_count;
        this.filters.total_page = res.total_page;
        if (this.data.length > 0) {
          this.ifShowEmpty = false;
        } else {
          this.ifShowEmpty = true;
        }
      })
      .catch(() => {
        loading.close();
      });
  }
}
